export const jobStatusLabel = (status) => {
  const normalized = (status || '').toString().toUpperCase().replace(/\s+/g, '_')
  const map = {
    DRAFT: 'Draft',
    PENDING_PAYMENT: 'Pending payment',
    PENDING_APPROVAL: 'Pending approval',
    LIVE: 'Live',
    CLOSED: 'Closed',
    EXPIRED: 'Expired',
    REJECTED: 'Rejected'
  }
  return map[normalized] || 'Unknown'
}

export const jobStatusColor = (status) => {
  const normalized = (status || '').toString().toUpperCase().replace(/\s+/g, '_')
  switch (normalized) {
    case 'LIVE':
      return 'bg-green-100 text-green-700'
    case 'PENDING_PAYMENT':
      return 'bg-yellow-100 text-yellow-700'
    case 'PENDING_APPROVAL':
      return 'bg-blue-100 text-blue-700'
    case 'CLOSED':
    case 'EXPIRED':
      return 'bg-red-100 text-red-700'
    case 'REJECTED':
      return 'bg-red-100 text-red-700'
    default:
      return 'bg-gray-100 text-gray-700'
  }
}

export const employmentTypeLabel = (type) => {
  const normalized = (type || '').toString().toUpperCase().replace(/\s+/g, '_')
  const map = {
    FULL_TIME: 'Full-time',
    PART_TIME: 'Part-time',
    CONTRACT: 'Contract',
    INTERNSHIP: 'Internship',
    TEMPORARY: 'Temporary'
  }
  return map[normalized] || type || 'Not specified'
}

export const locationTypeLabel = (type) => {
  const normalized = (type || '').toString().toUpperCase().replace(/\s+/g, '_')
  const map = {
    REMOTE: 'Remote',
    ONSITE: 'On-site',
    HYBRID: 'Hybrid'
  }
  return map[normalized] || type || 'Not specified'
}

export const applicationStatusLabel = (rawStatus) => {
  const normalized = (rawStatus || '').toString().toUpperCase().replace(/\s+/g, '_')
  const map = {
    APPLIED: 'Applied',
    ELIGIBILITY_CONFIRMED: 'Eligibility confirmed',
    INTERVIEW_IN_PROGRESS: 'Interview in progress',
    SUBMITTED: 'Interview submitted',
    UNDER_REVIEW: 'Under review',
    SELECTED: 'Selected',
    REJECTED: 'Rejected',
    EXPIRED: 'Expired'
  }
  return map[normalized] || 'In progress'
}

export const applicationStatusMeta = (rawStatus) => {
  const normalized = (rawStatus || '').toString().toUpperCase().replace(/\s+/g, '_')
  const colorMap = {
    APPLIED: 'bg-slate-100 text-slate-700',
    ELIGIBILITY_CONFIRMED: 'bg-blue-50 text-blue-700',
    INTERVIEW_IN_PROGRESS: 'bg-amber-50 text-amber-700',
    SUBMITTED: 'bg-sky-50 text-sky-800',
    UNDER_REVIEW: 'bg-amber-50 text-amber-800',
    SELECTED: 'bg-green-50 text-green-700',
    REJECTED: 'bg-red-50 text-red-700',
    EXPIRED: 'bg-slate-100 text-slate-500'
  }
  return {
    label: applicationStatusLabel(rawStatus),
    color: colorMap[normalized] || 'bg-slate-100 text-slate-700'
  }
}

export const companyStatusLabel = (status) => {
  const normalized = (status || '').toString().toUpperCase().replace(/\s+/g, '_')
  const map = {
    ACTIVE: 'Verified',
    PENDING_VERIFICATION: 'Pending verification',
    SUSPENDED: 'Suspended'
  }
  return map[normalized] || status || 'Unknown'
}
